var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-2"},[_c('v-alert',{attrs:{"type":"success"}},[_vm._v(" Imóvel excluído com sucesso! ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }